import { createTypes } from "reduxsauce";

export default createTypes(
  `   
    SET_USERINFO  
    SET_NUMBER_OF_QUESTIONS
    SET_SELECTED_ANSWER_COUNT
    RESET_SELECTED_ANSWER_COUNT
    DECREMENT_SELECTED_ANSWER_COUNT
    SET_SELECTED_PLAN
    SET_USERID
    SET_ASSESSMENT_ID
    SET_ASSESSMENT_ATTEMPT_ID
    SET_QUIZ_COMPLETE
    SET_CONFIRMATION_VIEW
    RESET_APP
    SET_ANSWER_COUNT
    SET_BACk_BUTTON_CLICK_COUNT
    SET_GUEST_USER
    SET_PREFILL_EMAIL
    SET_USER_GUID_BY_ADMIN_USER
    SET_ASSESSMENT_MAP_ID
    SET_OPTION_COUNT_OF_QUESTIONS
    SET_DASHBOARD_AB_TEST_VALUE

`,
  {
    prefix: "funnelstep/",
  },
);
